<template>
  <div id="gallery">
    <!-- Loading -->
    <LogoLoading v-if="loading" />
    <!-- Content -->
      <div v-else class="photo-container container">
      <GalleryThumb @showImage="showImage(index)" class="slider-thumb box" v-for="(content, index) in photos"
        :key="index" :galleryContent="content.image" />
      <NoResultsPlaceholder v-if="!photos.length"></NoResultsPlaceholder>
    </div>
    <FullScreenFile v-if="showImageIndex !== null" :startIndex="showImageIndex" @closeRequest="showImageIndex = null"
      :gallery="photos"></FullScreenFile>
  </div>
</template>

<script>
import GalleryThumb from "@/components/GalleryThumb.vue";
import LogoLoading from "@/components/LogoLoading.vue"
import { mapActions, mapState } from "vuex";
import InputGetList from "@/classes/InputGetList";
import FullScreenFile from "@/components/FullScreenFile.vue";
import { API_HELPER } from "@/helpers/api.js";
import NoResultsPlaceholder from "@/components/NoResultsPlaceholder.vue"

const DEFAULT_ITEMS_PER_PAGE = 8;

export default {
  components: { GalleryThumb, LogoLoading, FullScreenFile, NoResultsPlaceholder },
  data() {
    return {
      type: null,
      title: '',
      showImageIndex: null
    }
  },
  metaInfo() {
    return {
      title: this.$t("vueRoutes.galleryTitle"),
      titleTemplate: "%s - Quinta Do Barbusano",
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      meta: [
        { name: 'description', content: this.$t("vueRoutes.galleryDescription") },
        { name: 'keywords', content: this.$t("vueRoutes.galleryKeywords") },
          // Twitter Card
          // { name: "twitter:card", content: "summary" },
          // { name: "twitter:title", content: this.$t("vueRoutes.galleryTitle") },
          // { name: "twitter:description", content: this.$t("vueRoutes.galleryDescription")},

          // //Facebook OpenGraph
          // { property: "og:title", content: this.$t("vueRoutes.galleryTitle") },
          // { property: 'og:site_name', content: 'Quinta Do Barbusano' },
          // { property: "og:type", content: "website" },
          // { property: 'og:image', content: API_HELPER.pathJoin([process.env.VUE_APP_FRONT, "/default.jpg"]) },
          // { property: "og:description", content: this.$t("vueRoutes.galleryDescription")},
      ],
      link: [
        { rel: 'alternate', hreflang: 'en', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRoutes.gallery", 'en')]) },
        { rel: 'alternate', hreflang: 'pt', href: API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.$t("vueRoutes.gallery", 'pt')]) },
      ]
    }
  },
  mounted() {
    this.initializePage();
  },
  methods: {
    ...mapActions({
      getGallery: 'heros/getList',
    }),
    initializePage() {
      const itemsPerPage = 99;
      const currentPage = 1;
      const searchText = '';
      const sorter = 1; // asc
      const propertyName = "id";

      // Make request
      var input = new InputGetList(itemsPerPage, currentPage, sorter, propertyName, searchText);
      this.getGallery(input);
    },
    showImage(index) {
      this.showImageIndex = index;
    },
  },
  computed: {
    ...mapState({
      galleryOutput: state => state.heros.listOutput,
    }),
    loading() {
      return this.galleryOutput == null;
    },
    photos() {
      let result = [];
      if (this.galleryOutput && this.galleryOutput.data && this.galleryOutput.data.heroItems && this.galleryOutput.data.heroItems.length) {
        // Filter only gallery items
        result = this.galleryOutput.data.heroItems.filter(obj => obj.types && obj.types.some(typeObj => typeObj.type === 'Gallery'));
      }
      return result;
    },

  }
}
</script>

<style scoped>
/* Title */
h1 {
  font-size: 3rem !important;
}

.title {
  justify-content: center;
  display: flex;
}

.title h2 {
  margin: 0;
  font-weight: bold !important;
}

hr {
  opacity: 1 !important;
  background-color: transparent;
  border: 1px solid black !important;
  margin: 1rem auto;
}

.see>p {
  margin-top: 1rem;
  cursor: pointer;
}

.skeleton-box {
  min-height: clamp(160px, 28vw, 245px);
}

/* Size of poi elements: these are not done using bootstrap to have correct alignments, using gap */
.photo-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 25px;
  row-gap: 15px;
  column-gap: 25px;
  min-height: calc(100vh - 115px);
  margin: 180px auto 0;
  padding: 0 1rem 80px;
  max-width: 1400px;
  justify-items: center;
  align-items: start;
  align-content: start;
}

.photo-container>.slider-thumb,
.photo-container>span {
  width: 100%;
  max-width: 100%;
  height: clamp(160px, 28vw, 245px);
  margin: 0;
}

@media (max-width: 1400px) {
  .photo-container {
    max-width: 100%;
    padding: 0 2rem 80px;
  }
}

@media (max-width: 1199px) {
  .photo-container {
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 20px;
    row-gap: 12px;
    column-gap: 20px;
    padding: 0 1.5rem 60px;
    margin-top: 160px;
  }

  .photo-container>.slider-thumb,
  .photo-container>span {
    width: 100%;
    max-width: 100%;
    margin: 0;
    height: clamp(180px, 30vw, 280px);
  }
}

@media (max-width: 992px) {
  #menu-background {
    height: 80px;
  }
}

/* Header bar */
@media (max-width: 991px) {
  .photo-container {
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
    gap: 18px;
    row-gap: 10px;
    column-gap: 18px;
    padding: 0 1.5rem 50px;
    margin-top: 140px;
  }

  .photo-container>.slider-thumb,
  .photo-container>span {
    height: clamp(200px, 35vw, 300px);
  }
}

@media (max-width: 767px) {
  .photo-container.container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100% !important;
  }

  .photo-container {
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr)) !important;
    gap: 12px !important;
    row-gap: 8px !important;
    column-gap: 12px !important;
    padding: 0 1rem 40px !important;
    margin-top: 120px !important;
    justify-items: center !important;
  }

  .photo-container>.slider-thumb,
  .photo-container>span {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 0 !important;
    height: clamp(180px, 40vw, 250px) !important;
  }

  .photo-container .photo-box {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
  }

  .photo-container .photo-box .content {
    width: 100%;
    height: auto;
    min-height: 200px;
    aspect-ratio: 16/9;
    display: block;
  }
}

@media (max-width: 575px) {
  h1 {
    font-size: 2rem !important;
  }

  .photo-container.container {
    padding-left: 0 !important;
    padding-right: 0 !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    max-width: 100% !important;
  }

  .photo-container {
    grid-template-columns: 1fr !important;
    gap: 15px !important;
    row-gap: 15px !important;
    column-gap: 15px !important;
    padding: 0 1rem 40px !important;
    margin-top: 100px !important;
    justify-items: center !important;
  }

  .photo-container>.slider-thumb,
  .photo-container>span {
    width: 100% !important;
    max-width: 100% !important;
    margin: 0 !important;
    padding: 0 !important;
    line-height: 0 !important;
    height: clamp(250px, 50vw, 350px) !important;
  }
  
  /* Espaçamento normal em 1 coluna - sem margin negativo */
  .photo-container>.slider-thumb:nth-child(n+2),
  .photo-container>span:nth-child(n+2) {
    margin-top: 0 !important;
  }

  .photo-container .photo-box {
    width: 100% !important;
    max-width: 100% !important;
    height: auto !important;
    margin: 0 !important;
    padding: 0 !important;
    display: block !important;
  }

  .photo-container .photo-box .content {
    width: 100%;
    height: auto;
    min-height: 250px;
    aspect-ratio: 16/9;
    display: block;
  }

  .title h2 {
    font-size: 1rem;
  }
}
</style>
